import { ActionTypes } from "../constants";

const reduceContacts = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_CONTACTS_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_CONTACTS_FAILURE:
            return [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceContacts;
